import { useEffect, useState, type ReactNode } from 'react';
import { GatePage } from '../pages/Gate.tsx';
import { LegalStandalone, legalKindOf } from '../pages/Legal.tsx';
import { LOCKED_EVENT } from './gate-signal.ts';

/*
 * Zugangssperre fuer die ganze Seite -- das Gegenstueck zu server/src/gate.ts.
 * Solange der Server ein Zugangspasswort verlangt und dieser Browser es noch
 * nicht eingegeben hat, gibt es statt der App nur die Passwortseite. Die
 * Freigabe selbst ist ein Cookie, das der Server setzt; hier wird nur gefragt,
 * ob es schon da ist.
 */

export function SiteGate({ children }: { children: ReactNode }) {
  const [state, setState] = useState<'checking' | 'locked' | 'open'>('checking');

  useEffect(() => {
    let alive = true;
    fetch('/api/gate')
      .then((r) => r.json() as Promise<{ required: boolean; open: boolean }>)
      .then((r) => alive && setState(!r.required || r.open ? 'open' : 'locked'))
      // Server nicht erreichbar: dann die App zeigen -- die hat fuer diesen
      // Fall ihre eigenen Hinweise („API nicht erreichbar").
      .catch(() => alive && setState('open'));
    const onLocked = () => setState('locked');
    window.addEventListener(LOCKED_EVENT, onLocked);
    return () => {
      alive = false;
      window.removeEventListener(LOCKED_EVENT, onLocked);
    };
  }, []);

  if (state === 'checking') return null;
  if (state === 'locked') {
    /*
     * Impressum und Datenschutz bleiben auch ohne Passwort lesbar -- ein
     * Impressum muss „staendig verfuegbar" sein. Beide Texte stehen im
     * Bundle und brauchen keine API, die Sperre am Server bleibt also dicht.
     */
    const legal = legalKindOf(window.location.pathname);
    if (legal) return <LegalStandalone kind={legal} />;
    return <GatePage onOpen={() => setState('open')} />;
  }
  return <>{children}</>;
}
